import React from "react";
import T from "prop-types";
import classNames from "classnames";
import NoteTooltip from "../../NoteTooltip/NoteTooltip";

export default function CheckGroup({
  info,
  title,
  children,
  justified = false,
  checkGroupStyles
}) {
  const groupClasses = classNames("btn-group", {
    "btn-group-justified": justified
  });

  const infoIcon = info ? (
    <NoteTooltip
      color="rgba(255, 255, 255, 0.25)"
      icon="fa-info-circle"
      note={info}
    />
  ) : null;

  return (
    <div className="form-group" style={checkGroupStyles}>
      <label htmlFor={title}>
        {title}
        {infoIcon}
      </label>
      <br />
      <div className={groupClasses} data-toggle="buttons">
        {children}
      </div>
    </div>
  );
}

CheckGroup.propTypes = {
  info: T.oneOfType([T.string, T.element, T.arrayOf(T.element)]),
  title: T.string.isRequired,
  children: T.oneOfType([T.element, T.arrayOf(T.element)]),
  justified: T.bool,
  checkGroupStyles: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/Check/CheckGroup.jsx